import $ from 'jquery';
import _ from 'underscore';
import Router from 'root/router';
import UI from 'root/ui';
import Cache from 'root/cache';
import View from 'view/base';
import View_Form_Apperance from 'view/survey_designer/form_apperance';
import View_Form_Targets from 'view/survey_designer/form_targets';
import View_Form_Triggers from 'view/survey_designer/form_triggers';
import View_Form_More from 'view/survey_designer/form_more';
import View_Question_List from 'view/survey_designer/question_list';
import View_Preview from 'view/survey_designer/preview';
import View_Project_Name from 'view/project/name_inline_edit';
import View_Widget_Demo from 'view/widget_demo';
import Survey_Question from '../../model/survey_question';
import Widget_Code from 'view/widget_code';
import Modal from 'root/module/modal';
import Modals from 'root/modals';
import Survey_Question_Model from 'root/model/survey_question';
import Survey_Model from 'model/survey';

export default View.extend({
    className: 'survey-designer',

    step: 'design',

    views: {
        form_apperance: {},
        form_targets: {},
        form_triggers: {},
        form_more: {},
        question_list: {},
        preview: {},
        widget_code: {},
        project_name: {},
        widget_demo: {}
    },

    events: {
        'click .form-steps > span'        : 'onSelectStep',
        'click .help-btn'                 : 'onHelp',
        'click .survey-edit-save'         : 'onSurveySave',
        'click .survey-edit-exit'         : 'onSurveyExit',
        'click .demo-address-bar-refresh' : 'onRefeshDemo'
    },

    dom_handlers: {
        onSelectStep: function(e) {
            var step_next = $(e.currentTarget).data('val');

            if (this.step === 'audience' && step_next === 'install' && !this.no_domain_confirmed) {
                var project_domains = this.views.form_targets.getDomains();

                if (!project_domains.length) {
                    Modal.open({
                        title: 'No domains added',
                        content: '<p>You need to add your app or website domains to install the code. However, you can still collect responses by sharing the survey URL without installing the code.</p><p>Are you sure you don’t want to add any domains? </p>',
                        button: {
                            'Confirm': () => {
                                this.no_domain_confirmed = true;

                                this.goToStep(step_next);
                                Modal.close();
                            }
                        },
                        button_class: 'secondary'
                    });

                    return;
                }
            }

            if (step_next === 'demo' && this.isChanged()) {
                var modal = Modal.open({
                    title: 'Unsaved Changes',
                    content: '<p>You have unsaved changes. To preview the changes, you will need to save them first.</p>',
                    button: {
                        'Save Changes': () => {
                            this.doSave(() => {
                                this.goToStep(step_next);
                                Modal.close();
                            });
                        }
                    },
                    button_html: '<button class="tertiary margin-right-12 donot-save" type="button">Don\'t save</button>'
                });

                modal.find('.donot-save').click((e) => {
                    this.goToStep(step_next);
                    Modal.close();
                });

                return;
            }

            this.goToStep(step_next);
        },

        onHelp: function(e) {
            UI.openLiveChat();
        },

        onSurveySave: function(e) {
            if (!Cache.app.isAdmin()) {
                Modal.open({
                    title: 'Admin user required',
                    content: '<p>You do not have permission to edit this survey.</p>',
                    button: {
                        OK: () => {
                            Modal.close();
                        }
                    }
                });
                return;
            }

            Modal.confirm('<p>Are you sure you want to save these changes? Once saved, the changes will be updated in your survey immediately.</p>', () => {
                this.doSave();
            }, undefined, 'Yes, save');
        },

        onSurveyExit: function (e) {
            if (!Cache.app.isAdmin()) {
                this.cancelEdit();
                return;
            }

            if (this.isChanged()) {
                const modal = Modal.open({
                    title: 'Save changes',
                    content: '<p>You have unsaved changes. Do you want to save them before exiting?</p>',
                    button: {
                        'Save Changes': () => {
                            Modal.close();
                            this.doSave();
                            this.cancelEdit();
                        },
                    },
                    button_html: '<button class="tertiary margin-right-12 donot-save" type="button">Don\'t Save</button>'
                });

                modal.find('.donot-save').click((e) => {
                    Modal.close();
                    this.cancelEdit();
                });
            } else {
                this.cancelEdit();
            }
        },

        onRefeshDemo: function() {
            this.$el.find('.demo-window iframe').get(0).contentWindow.postMessage('userback_reload');
        }
    },

    event_handlers: {
        onSurveyEdit: function() {
            this.$el.find('.region-setting-container[data-mode="start"]').hide();
            this.$el.find('.region-setting-container[data-mode="edit"]').show();

            Router.addQueryString('s', 'edit', {trigger: false});
            this.views.preview.trigger('Preview:AdjustCanvas');
            this.resetSelectedQuestion();
        },

        onSurveyChange: function() {
            var changed = this.isChanged();

            this.$el.find('.survey-edit-save').prop('disabled', !changed);

             // Send the survey data to the iframe
            this.views.preview.trigger('Preview:PostMessage', 'survey/updateSurvey');

            this.views.preview.trigger('Preview:AdjustCanvas');
            this.updateQuestionSaveBtnStatus();
        },

        onDomainChange: function() {
            var changed = this.isChanged();
            this.$el.find('.survey-edit-save').prop('disabled', !changed);
        },

        onPageConditionChange: function() {
            var changed = this.isChanged();
            this.$el.find('.survey-edit-save').prop('disabled', !changed);
        },

        onQuestionDelete: function() {
            var changed = this.isChanged();

            this.$el.find('.survey-edit-save').prop('disabled', !changed);

            // Send message to canvas to update the questions
            this.views.preview.trigger('Preview:PostMessage', 'survey/updateQuestions');

            // find the first question
            var first_question = this.survey_questions.first();
            if (first_question) {
                this.selectQuestion(first_question);
            }
        },

        onQuestionSelect: function(model, should_post_message = true) {
            this.selectQuestion(model, should_post_message);
        },

        onQuestionSelectInPreview: function(model) {
            this.selectQuestion(model, false, true);
        },

        onQuestionUpdate: function(e) {
            var changed = this.isChanged();
            this.$el.find('.survey-edit-save').prop('disabled', !changed);

            // Send message to canvas to update the questions
            this.views.preview.trigger('Preview:PostMessage', 'survey/updateQuestions');
            this.views.preview.trigger('Preview:PostMessage', 'survey/selectQuestion');
        },

        onQuestionReset: function() {
            this.views.preview.trigger('Preview:PostMessage', 'survey/updateQuestions');
        },

        onQuestionsAdd: function(type, sub_type) {
            if (!this.isValidQuestionType(type)) {
                return
            };

            var is_welcome_or_thankyou = type === 'welcome' || type === 'thankyou';

            if (is_welcome_or_thankyou) {
                var existing = this.survey_questions.findWhere({question_type: type});
                if (existing) {
                    return;
                }
            }

            var question_sort = 1;

            if (type !== 'welcome') {
                // add new question to the bottom
                var form_questions = this.survey_questions.filter((model) => {
                    return model.get('question_type') !== 'thankyou' && model.get('question_type') !== 'welcome';
                });

                if (form_questions.length > 0) {
                    var last_question = form_questions[form_questions.length - 1];
                    question_sort = last_question.get('question_sort') + 1;
                }
            }

            // update the sort of the questions after the new question
            if (type !== 'thankyou') {
                this.survey_questions.each((model) => {
                    var current_sort = model.get('question_sort');
                    if (current_sort >= question_sort) {
                        model.set('question_sort', current_sort + 1);
                    }
                });
            }

            // welcome sort is 1, thankyou sort is the last, other question sort is the next of the selected question
            if (type === 'welcome') {
                question_sort = 1;
            } else if (type === 'thankyou') {
                question_sort = this.survey_questions.length + 1;
            }

            var question = this.buildNewQuestion(type, sub_type, question_sort);
            this.survey_questions.add(question);
            this.survey_questions.sort();

            this.views.preview.trigger('Preview:PostMessage', 'survey/updateQuestions');

            this.selectQuestion(question, true, true);
        },

        onQuestionsDuplicate: function(model) {
            var question = model.clone();
            var unique_key = 'temp_' + Date.now();

            var question_sort = question.get('question_sort');
            question.set({
                id: unique_key,
                question_key: unique_key,
                question_sort: question_sort + 1,
            });

            this.survey_questions.each((model) => {
                var current_sort = model.get('question_sort');
                if (current_sort > question_sort) {
                    model.set('question_sort', current_sort + 1);
                }
            });

            this.survey_questions.add(question);
            this.survey_questions.sort();

            this.views.preview.trigger('Preview:PostMessage', 'survey/updateQuestions');

            this.selectQuestion(question);
        },

        onQuestionChange: function(question_type, question_sub_type) {
            if (!this.isValidQuestionType(question_type)) return;

            const {label, desc, options, scale} = this.getDefaultQuestionInfo(question_type, question_sub_type);

            // if swap between dropdown and multiple, keep the options
            // verse versa
            var question_options;
            if (
                this.selected_question.get('question_type') === 'dropdown' && question_type === 'multiple'
                || (this.selected_question.get('question_type') === 'multiple' && question_type === 'dropdown')
            ) {
                question_options = this.selected_question.get('question_options');
            } else {
                question_options = options
            }

            // update the selected question
            this.selected_question.set({
                question_type                : question_type,
                question_sub_type            : question_sub_type,
                question_label               : this.selected_question.get('question_label') || label,
                question_description         : this.selected_question.get('question_description') || desc,
                question_options             : question_options,
                is_required                  : false,
                logo_url                     : '',
                button_text                  : '',
                hint_text                    : '',
                character_limit              : '',
                is_number                    : false,
                answer_layout                : '',
                is_multiple_select           : false,
                scale                        : scale,
                scale_label                  : '',
                answer_order                 : '',
                other_answer_type            : '',
                other_answer_hint_text       : '',
                other_answer_character_limit : '',
            });

            this.views.preview.trigger('Preview:PostMessage', 'survey/updateQuestions');
        },

        onQuestionsChange: function() {
            this.views.preview.trigger('Preview:PostMessage', 'survey/updateQuestions');
        },

        onTemplateOpen: function() {
            this.openTemplateGallery();
        }
    },

    goToStep: function(step) {
        Router.addQueryString('s', step, {trigger: false});

        this.step = step;
        this.$el.attr('data-step', this.step);

        this.$el.find('.form-steps > span')
            .removeClass('active')
            .filter('[data-val="' + this.step + '"]').addClass('active');

        if (step === 'design') {
            this.views.preview.trigger('Preview:AdjustCanvas');
            this.resetSelectedQuestion();
        }

        if (step === 'demo') {
            this.views.widget_demo.start();
        }
    },

    resetSelectedQuestion: function() {
        this.selected_question = this.survey_questions.at(0);
        // inform the preview view to update the selected question
        this.views.preview.trigger('Preview:SelectQuestion', this.selected_question);

        this.selectQuestion(this.selected_question);
    },

    selectQuestion: function(model, should_post_message = true, open_settings = false) {
        this.selected_question = model;

        // inform the preview view to update the selected question
        this.views.preview.trigger('Preview:SelectQuestion', this.selected_question);

        if (should_post_message) {
            this.views.preview.trigger('Preview:PostMessage', 'survey/selectQuestion');
        }

        if (open_settings) {
            this.views.question_list.openSettings(this.selected_question);
        }

        this.updateQuestionSaveBtnStatus();
    },

    onBeforeProjectChange: function() {
        // use a function so that the default unsaved changes message won't be used
        return this.isChanged() ? (change_project) => {
            this.warnUnsavedChanges(() => {
                change_project();
            });
        } : true;
    },

    warnUnsavedChanges: function(discard_callback) {
        Modal.open({
            title: 'Unsaved Changes',
            content: 'You have unsaved changes. Are you sure you want to discard them?',
            button: {
                'Yes, discard': () => {
                    discard_callback();
                }
            },
            text_link: {
                Cancel: (e) => {
                    e.preventDefault();
                    Modal.close();
                }
            }
        });
    },

    initialize: function(options) {
        this.onExit = options.onExit;
        this.hide_animation = !!options.hide_animation;

        if (['design', 'demo', 'audience', 'install'].indexOf(Router.getQueryString('s')) !== -1) {
            this.step = Router.getQueryString('s');
        }

        // clone the model and collections so that we can apply UI changes into the model without affecting the real data
        // TODO: to allow get survey by survey id instead of project id for scalability
        this.survey = Cache.survey.findWhere({project_id: Cache.default_project_id}).clone();

        var cloned_survey_questions = Cache.survey_question.clone();
        cloned_survey_questions.reset(
            Cache.survey_question.map(function(model) {
                return model.clone();
            })
        )
        this.survey_questions = cloned_survey_questions;

        this.selected_question = this.survey_questions.at(0);

        this.views.question_list = new View_Question_List({
            collection: this.survey_questions,
            survey: this.survey
        });

        this.views.preview = new View_Preview({
            collection: this.survey_questions,
            model: this.selected_question,
            survey: this.survey,
            mode: (this.step === 'design' ? 'edit' : 'preview')
        });

        this.views.widget_code = new Widget_Code({
            show_all_projects: false
        });

        this.views.project_name = new View_Project_Name({
            model: Cache.getDefaultProject()
        });

        this.views.widget_demo = new View_Widget_Demo();

        this.listenTo(this.survey,                'change',           this.event_handlers.onSurveyChange);
        this.listenTo(this.survey_questions,      'change',           this.event_handlers.onQuestionUpdate);
        this.listenTo(this.survey_questions,      'reset',            this.event_handlers.onQuestionReset);
        this.listenTo(this.survey_questions,      'remove',           this.event_handlers.onQuestionDelete);

        this.listenTo(this.views.question_list,   'Question:Select',     this.event_handlers.onQuestionSelect);
        this.listenTo(this.views.question_list,   'Question:Change',     this.event_handlers.onQuestionChange);
        this.listenTo(this.views.question_list,   'Question:Add',        this.event_handlers.onQuestionsAdd);
        this.listenTo(this.views.question_list,   'Question:Duplicate',  this.event_handlers.onQuestionsDuplicate);

        this.listenTo(this.views.preview,         'Question:Select',      this.event_handlers.onQuestionSelectInPreview);
        this.listenTo(this.views.preview,         'Template:Open',        this.event_handlers.onTemplateOpen);
    },

    isValidQuestionType: function(type) {
        return [
            'short',
            'long',
            'datetime',
            'yesno',
            'multiple',
            'dropdown',
            'rating',
            'nps',
            'thankyou',
            'welcome'
        ].includes(type);
    },

    getDefaultQuestionInfo: function(type, sub_type) {
        var label = '';
        var desc = '';
        var options = '';
        var scale;

        switch (type) {
            case 'multiple':
                options = JSON.stringify(['Answer 1', 'Answer 2', 'Answer 3']);
                break;
            case 'dropdown':
                options = JSON.stringify([
                    'Answer 1',
                    'Answer 2',
                    'Answer 3',
                ]);
                break;
            case 'nps':
                label = 'How likely are you to recommend us to a friend or colleague?';
                break;
            case 'rating':
                if (sub_type === 'thumb') {
                    scale = 2;
                } else {
                    scale = 5;
                }
                break;
            case 'thankyou':
                label = 'Thank!';
                desc = 'We really appreciate your feedback.';
                break;
            case 'welcome':
                label = 'Welcome to our survey!';
                break;
            default:
                break;
        }

        return {
            label: label,
            desc: desc,
            options: options,
            scale: scale
        };
    },

    buildNewQuestion: function(type, sub_type, sort) {
        const {label, desc, options, scale} = this.getDefaultQuestionInfo(type, sub_type);

        const unique_key = 'temp_' + Date.now();

        return new Survey_Question({
            id: unique_key,
            question_key: unique_key,
            question_type: type,
            question_sub_type: sub_type,
            question_label: label,
            question_desc: desc,
            question_sort: sort,
            question_options: options,
            scale: scale
        });
    },

    openTemplateGallery: function(template_code) {
        Modals.openTemplateGallery(template_code, (template_code) => {
            if (this.survey.get('first_active_time') === 0) {
                var templates = Cache.get('survey_templates') || [];

                if (template_code) {
                    var template = templates.find((item) => item.template_code === template_code);

                    if (template) {
                        var {questions, ...survey} = template;
                        var survey_model = new Survey_Model();

                        const filtered_survey = Object.keys(survey_model.defaults)
                            .filter(key => survey.hasOwnProperty(key))
                            .reduce((obj, key) => {
                                obj[key] = survey[key];
                                return obj;
                            }, {});

                        this.survey.set(filtered_survey);

                        questions.forEach((question, index) => {
                            const unique_key = 'temp_' + index + '_' + Date.now();
                            question.question_key = unique_key;
                            question.id = unique_key;
                        });

                        this.survey_questions.reset(questions);

                        // select first question
                        this.selectQuestion(this.survey_questions.at(0));

                        this.rebuildSurveySettingView();
                    } else {
                        // Open the template gallery to preview if the template data doesn't exist (refresh page or share url).
                        this.openTemplateGallery(template_code);
                    }
                }
            }
        }, undefined, 'survey');
    },

    isChanged: function() {
        // TODO: to allow get survey by survey id instead of project id for scalability
        var survey = Cache.survey.findWhere({project_id: Cache.default_project_id});

        var is_domain_changed = this.views.form_targets.getDomains().join(',') !== Cache.project_domain.where({project_id: Cache.default_project_id}).map((model) => {
            return model.get('domain');
        }).join(',');

        var is_survey_changed = JSON.stringify(survey.toJSON()) !== JSON.stringify(this.survey.toJSON());

        // check survey_questions has changed
        // Loop through the this.survey_questions and filterout those that are not in the Survey_Question_Modal default properties
        var filtered_survey_questions = [];
        var survey_question_model = new Survey_Question_Model();
        var survey_question_defaults = survey_question_model.defaults;

        this.survey_questions.each((model) => {
            var model_json = model.toJSON();
            // filter out the properties that are not in the default properties
            var keys_to_pick = Object.keys(survey_question_defaults);
            var filtered_model = {};
            keys_to_pick.forEach((key) => {
                if (model_json.hasOwnProperty(key)) {
                    filtered_model[key] = model_json[key];
                }
            });

            filtered_survey_questions.push(filtered_model);
        });
        var is_survey_questions_changed = JSON.stringify(Cache.survey_question.toJSON()) !== JSON.stringify(filtered_survey_questions);
        return is_survey_changed || is_survey_questions_changed || is_domain_changed;
    },

    doSave: function(on_success) {
        var submit_button = this.$el.find('.survey-edit-save');
        submit_button.prop('disabled', true).addClass('loading');

        // Save Domain
        // project domains
        var project_domains = this.views.form_targets.getDomains();
        Cache.app.request({
            action: 'project/update',
            data: {
                project_id: Cache.default_project_id,
                project_domains: project_domains.length ? project_domains : ['']
            },
            success: (response) => {
                Cache.project_domain.where({project_id: Cache.default_project_id}).forEach((model) => {
                    Cache.project_domain.remove(model);
                });

                Cache.project_domain.add(response.project_domain);
            }
        });

        // Save Survey
        var selected_question_id = this.selected_question.get('id');

        // Convert each items of this.survey_questions to JSON and combine them to an array
        var survey_questions_json = [];
        this.survey_questions.each((model) => {
            survey_questions_json.push(JSON.stringify(model.attributes));
        });

        const survey_attributes = this.survey.attributes;

        // clean up page condition
        let page_condition = this.survey.get('page_condition');
        try {
            page_condition = JSON.parse(page_condition);

            // get rid of empty conditions
            page_condition.conditions = page_condition.conditions.filter(condition => condition.type && condition.value);
        } catch (e) {
            page_condition = {
                operator: 'or',
                conditions: []
            };
        }

        survey_attributes.page_condition = JSON.stringify(page_condition);

        Cache.app.request({
            action: 'survey/update',
            data: {
                survey: survey_attributes,
                questions: survey_questions_json
            },
            success: (response) => {
                // TODO: to allow get survey by survey id instead of project id for scalability
                var survey = Cache.survey.findWhere({project_id: Cache.default_project_id});

                UI.success('Changes saved.');
                survey.set(response.survey);
                Cache.survey_question.set(response.questions);

                this.survey.set(response.survey);
                this.survey_questions.reset(response.questions);

                var selected_question;
                if (response.ids_map && Object.keys(response.ids_map).length > 0) {
                    selected_question_id = response.ids_map[selected_question_id];
                    selected_question = this.survey_questions.findWhere({id: selected_question_id});
                } else {
                    selected_question = this.survey_questions.findWhere({id: selected_question_id});
                }

                if (!selected_question) {
                    // if the selected question is deleted, select the first question
                    selected_question = this.survey_questions.first();
                }
                this.views.preview.trigger('Preview:PostMessage', 'survey/loadAll');
                this.selectQuestion(selected_question, false, true);
                submit_button.prop('disabled', true);

                if (on_success) {
                    on_success();
                }
            },
            complete: () => {
                submit_button.removeClass('loading');
            }
        });

        // onboarding
        Cache.app.trackProjectOnboarding('edit_survey', 1);
    },

    cancelEdit() {
        if (this.onExit) {
            this.onExit();
        }

        this.remove();
    },

    updateQuestionSaveBtnStatus: function() {
        var is_welcome_question = this.selected_question.get('question_type') === 'welcome';
        var has_survey_actived = this.survey.get('first_active_time') > 0;

        this.$el.find('.question-change').toggleClass('disabled', is_welcome_question || has_survey_actived);
    },

    rebuildSurveySettingView: function() {
        if (this.views.form_apperance instanceof View_Form_Apperance) {
            this.views.form_apperance.remove();
        }

        if (this.views.form_targets instanceof View_Form_Targets) {
            this.views.form_targets.remove();
        }

        if (this.views.form_triggers instanceof View_Form_Triggers) {
            this.views.form_triggers.remove();
        }

        if (this.views.form_more instanceof View_Form_More) {
            this.views.form_more.remove();
        }

        this.views.form_apperance = new View_Form_Apperance({model: this.survey});
        this.views.form_targets   = new View_Form_Targets({model: this.survey});
        this.views.form_triggers  = new View_Form_Triggers({model: this.survey});
        this.views.form_more      = new View_Form_More({model: this.survey});

        this.views.form_apperance.render().$el.appendTo(this.$el.find('.region-form-appearance'));
        this.views.form_targets.render().$el.appendTo(this.$el.find('.region-audience'));
        this.views.form_triggers.render().$el.appendTo(this.$el.find('.region-audience'));
        this.views.form_more.render().$el.appendTo(this.$el.find('.region-form-more'));

        this.listenTo(this.views.form_targets, 'Domain:Change', this.event_handlers.onDomainChange);
    },

    render: function() {
        if (this.hide_animation) {
            this.$el.addClass('hide-animation');
        }

        var content =
        '<div class="region-header">' +
            '<div class="region-project-name"></div>' +
            '<div>' +
                '<div class="form-steps badge-group-tertiary">' +
                    '<span class="min" data-val="design">Design</span>' +
                    '<span class="min" data-val="audience">Target</span>' +
                    '<span class="min" data-val="demo">Preview</span>' +
                    '<span class="min" data-val="install">Install</span>' +
                '</div>' +
            '</div>' +
            '<div class="region-save-btns">' +
                '<div>' +
                    '<button type="button" class="help-btn margin-right-16"><i class="fa-regular fa-question-circle"></i></button>' +
                    '<button type="button" class="survey-edit-save primary small min margin-right-8">Save</button>' +
                    '<button type="button" class="survey-edit-exit btn-close"><i class="fa-regular fa-xmark"></i></button>' +
                '</div>' +
            '</div>' +
        '</div>' +
        '<div class="region-main">' +
            '<div class="region-preview"></div>' +
            '<div class="region-right">' +
                '<div class="region-setting-container">' +
                    '<div class="region-general">' +
                        '<div class="tab">' +
                            '<div class="tab-menu">' +
                                '<a href="#" class="active">Questions</a>' +
                                '<a href="#">Appearance</a>' +
                                '<a href="#">More</a>' +
                            '</div>' +
                            '<div class="tab-content">' +
                                '<div class="region-form-layout active">' +
                                    '<div class="setting-title">Components</div>' +
                                    '<div class="margin-bottom-24">Drag and drop components to change the order</div>' +
                                    '<div class="region-question-list"></div>' +
                                '</div>' +
                                '<div class="region-form-appearance"></div>' +
                                '<div class="region-form-more"></div>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</div>' +
            '<div class="region-demo"></div>' +
            '<div class="region-audience"></div>' +
            '<div class="region-install"></div>' +
        '</div>';

        this.$el.html(content);

        this.views.project_name.render().$el.appendTo(this.$el.find('.region-project-name'));
        this.views.question_list.render().$el.appendTo(this.$el.find('.region-question-list'));
        this.views.preview.render().$el.appendTo(this.$el.find('.region-preview'));
        this.views.widget_demo.render().$el.appendTo(this.$el.find('.region-demo'));
        this.views.widget_code.render().$el.appendTo(this.$el.find('.region-install'));

        this.rebuildSurveySettingView();

        this.goToStep(this.step);

        this.$el.find('.survey-edit-save').prop('disabled', true);

        this.updateQuestionSaveBtnStatus();

        return this;
    }
});